{
    "comment_slider.response": "contribution",
    "comment_slider.responses": "contributions",
    "login.continue_with": "Continuer avec SSR",
    "question.input_placeholder": "Votre solution :",
    "upvote.count": "Soutenu {count}x"
}
